/**
 * 操作台的分頁按鈕。
 *
 * 原本是 `CustomerConsolePage` 裡的本地函式,REQ-20260918002 把廠商操作台也改成
 * 同一排分頁,所以搬到這裡共用 —— 底線分頁的外觀**逐字沿用**,沒有順手改樣式。
 *
 * `tone="alert"` 是本次新增的選用狀態(預設 `default` = 原本的外觀):
 * 「還有沒做完的提醒」要在切到別的分頁時也看得見,所以借用訪談列上
 * 「🔔 提醒中」那顆按鈕的同一組琥珀色 class(`InterviewTimeline`),
 * 讓使用者一眼認出這兩個東西是同一種「提醒」。
 */
export function TabButton(props: {
  active: boolean;
  onClick: () => void;
  testId: string;
  /** alert = 琥珀色(有未完成的提醒);預設為一般底線分頁 */
  tone?: 'default' | 'alert';
  children: React.ReactNode;
}): JSX.Element {
  const base = 'px-4 py-2 text-sm border-b-2 -mb-px transition-colors';
  const cls =
    props.tone === 'alert'
      ? // 與 InterviewTimeline 的「🔔 提醒中」同一組色;作用中時再壓一條藍底線標示位置
        `bg-amber-100 border-amber-300 text-amber-800 hover:bg-amber-200${
          props.active ? ' border-blue-600 font-semibold' : ''
        }`
      : props.active
        ? 'border-blue-600 text-blue-700 font-semibold'
        : 'border-transparent text-slate-600 hover:text-slate-900';
  return (
    <button
      type="button"
      onClick={props.onClick}
      className={`${base} ${cls}`}
      data-testid={props.testId}
    >
      {props.children}
    </button>
  );
}
